import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { loadPlayer, loadSurvey } from '../actions';
import { resetErrorMessage } from 'actions/internal';
import TopNavBarPlayer from './nav/TopNavBarPlayer';
import ASQSidebarContainer from './asq/ASQSidebarContainer';
import ASQSurveyContainer from './asq/ASQSurveyContainer';
import { LoadingSpinner } from 'components/helpers/LoadingSpinner';
import { getLoaders, getSurvey, getTitle } from 'selectors';
import { appNamedRoutes } from 'routes';


class ASQSurveyPage extends React.Component {
  componentDidMount() {
    this.props.resetErrorMessage();
    this.props.loadPlayer(this.props.match.params, {source: 'init'});
    this.props.loadSurvey(this.props.match.params, {source: 'init'});
  }

  render() {
    if (!this.props.isAuthChecked) return null;
    const { isLoading, match, playerId, surveyId, title } = this.props;
    if (playerId !== parseInt(match.params.player_id, 10) ||
        surveyId !== parseInt(match.params.id, 10) || isLoading) {
      return (
        <DocumentTitle title={title}>
          <div className='row'>
            <div className='column u-margin-top--large'>
              <LoadingSpinner bgColor='light' />
            </div>
          </div>
        </DocumentTitle>
      );
    }
    const locationFrom = get(this.props.location, 'state.from', { pathname: appNamedRoutes.asqs });
    return (
      <DocumentTitle title={title}>
        <div>
          <TopNavBarPlayer locationFrom={locationFrom}/>
          <div className="row u-navbar-padding">
            <div className="column o-sections__wrap">
              <ASQSurveyContainer locationFrom={locationFrom}/>
            </div>
            <div className="column o-sidebar o-sidebar--fixed">
              <ASQSidebarContainer />
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthChecked: state.auth.isAuthChecked,
    isLoading: getLoaders(state, ['PLAYER', 'START_SURVEY']),
    playerId: get(state.survey.player, 'id', 0),
    surveyId: get(state.survey.survey, 'result', 0),
    title: getTitle(getSurvey(state), 'name'),
  }
}

ASQSurveyPage.propTypes = {
  isAuthChecked: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loadPlayer: PropTypes.func.isRequired,
  loadSurvey: PropTypes.func.isRequired,
  resetErrorMessage: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  playerId: PropTypes.number,
  surveyId: PropTypes.number,
  title: PropTypes.string.isRequired,
}

export default connect(mapStateToProps, { loadSurvey, loadPlayer, resetErrorMessage })(ASQSurveyPage);
